function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M33.32,29.47a7.22,7.22,0,0,1-2.17,2.85,7.11,7.11,0,0,1-2.4,1.24,14.88,14.88,0,0,1-4.1.43H9.35a14.88,14.88,0,0,1-4.1-.43,7.11,7.11,0,0,1-2.4-1.24A7.22,7.22,0,0,1,.68,29.47,13.25,13.25,0,0,1,0,24.65H0V9.35H0A13.25,13.25,0,0,1,.68,4.53,7.22,7.22,0,0,1,2.85,1.68,7.11,7.11,0,0,1,5.25.44,14.88,14.88,0,0,1,9.35,0h15.3a14.88,14.88,0,0,1,4.1.43,7.11,7.11,0,0,1,2.4,1.24,7.22,7.22,0,0,1,2.17,2.85A13.25,13.25,0,0,1,34,9.35v15.3A13.25,13.25,0,0,1,33.32,29.47Z",
  fill: "#000"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M23.21,15.8a1,1,0,0,0,1.35-.34,1,1,0,0,0-.35-1.36c-3.89-2.32-10.06-2.54-13.77-1.41A1,1,0,0,0,11,14.58C14.24,13.59,19.83,13.78,23.21,15.8Zm-.11,3a.83.83,0,0,0-.27-1.14A15.26,15.26,0,0,0,11,16.26a.82.82,0,0,0,.47,1.58A13.67,13.67,0,0,1,22,19.07.83.83,0,0,0,23.1,18.8Zm-1.28,2.87a.66.66,0,0,0-.22-.9c-2.77-1.71-6.2-2.1-10.2-1.18a.66.66,0,0,0,.29,1.28c3.66-.84,6.76-.5,9.23,1A.65.65,0,0,0,21.82,21.67ZM17,6.44A10.56,10.56,0,1,1,6.5,17,10.53,10.53,0,0,1,17,6.44Z",
  fill: "#1ed760"
});

function SvgSpotify(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotify);
export default __webpack_public_path__ + "static/media/spotify.53a6388c.svg";
export { ForwardRef as ReactComponent };